const FlagPL = props => (
	<svg height="28" viewBox="0 0 200 200" width="28" {...props}>
		<rect fill="#fff" width="200" height="100" />
		<rect fill="#ed5565" y="100" width="200" height="100" />
	</svg>
);

export default FlagPL;
